"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = void 0;
/* eslint-disable no-console */
const react_1 = require("react");
const authUtils_1 = require("../utils/authUtils");
const useAuth = (authConfig) => {
    const [authToken, setAuthToken] = (0, react_1.useState)((0, authUtils_1.getCookieValue)('authToken'));
    const [isAuthenticated, setIsAuthenticated] = (0, react_1.useState)(!!(0, authUtils_1.getCookieValue)('authToken'));
    const refreshAccessToken = (0, react_1.useCallback)(async () => {
        const newToken = await (0, authUtils_1.refreshAccessToken)(authConfig);
        setAuthToken(newToken);
        setIsAuthenticated(!!newToken);
        return newToken;
    }, [authConfig]);
    const handleLogin = (0, react_1.useCallback)(() => {
        if (!authConfig?.redirectUrl && !authConfig?.authUrl && !authConfig?.scope) {
            console.error('Auth config is misconfigured');
            return;
        }
        const encodedRedirectUrl = encodeURIComponent(authConfig.redirectUrl);
        const loginUrl = `${authConfig?.authUrl}?client_id=${authConfig?.clientId}&scope=${authConfig?.scope}&redirect_uri=${encodedRedirectUrl}&response_type=code&state=state`;
        const popup = window.open(loginUrl, 'Login', 'width=600,height=600');
        if (!popup) {
            console.error('Popup failed to open');
            return;
        }
        const checkPopup = setInterval(() => {
            try {
                if ((0, authUtils_1.getCookieValue)('authToken') && (0, authUtils_1.getCookieValue)('refreshToken')) {
                    clearInterval(checkPopup);
                    popup.close();
                    setAuthToken((0, authUtils_1.getCookieValue)('authToken'));
                    setIsAuthenticated(true);
                }
            }
            catch (error) {
                // Ignore cross-origin access errors
            }
            if (popup.closed) {
                clearInterval(checkPopup);
                console.error('Popup closed before authentication');
            }
        }, 1000); // Check every second
    }, [authConfig]);
    (0, react_1.useEffect)(() => {
        refreshAccessToken().catch(() => {
            setIsAuthenticated(false);
        });
    }, [authConfig, refreshAccessToken]);
    return {
        authToken,
        isAuthenticated,
        login: handleLogin,
        refreshAccessToken,
    };
};
exports.useAuth = useAuth;
